import Vue from 'vue';

import { StandGuidanceService } from "@/api";
import {
    STANDGUIDANCE_FETCH,
    STANDGUIDANCE_BOOKED,
    STANDGUIDANCE_BOOK,
    STANDGUIDANCE_CANCEL,
} from "@/store/actions.type";

import {
    FETCH_START,
    FETCH_END,
    BOOK_START,
    BOOK_END,
    CANCEL_START,
    CANCEL_END,
    SET_STANDGUIDANCE,
    SET_STANDGUIDANCE_BOOKING,
    SET_BOOKED_STANDGUIDANCE,
    SET_STANDGUIDANCE_CANCELLED,
} from "@/store/mutations.type";

const state = () => ({
    isLoading: false,
    isBooking: false,
    isCancelling: false,
    appointment: null,
    appointments: {},
});

const actions = {

    async [STANDGUIDANCE_FETCH]({ commit, state }) {

        commit(FETCH_START);

        try {
            const { data } = await StandGuidanceService.get();
            commit(SET_STANDGUIDANCE, {
                data: data
            });

            return data;

        } catch(e) {
            commit(FETCH_END);
        }

        return null;
    },

    async [STANDGUIDANCE_BOOKED]({ commit, state }) {

        commit(FETCH_START);

        try {
            const { data } = await StandGuidanceService.getBookedStandGuidance();
            commit(SET_BOOKED_STANDGUIDANCE, data);

            return data;

        } catch(e) {
            commit(FETCH_END);
        }

        return null;
    },

    async [STANDGUIDANCE_BOOK]({ commit, state }, bookingData) {

        if (state.isBooking) {
            return;
        }

        commit(BOOK_START);

        try {

            const { data } = await StandGuidanceService.book(bookingData);
            if (data.success) {
                commit(SET_STANDGUIDANCE_BOOKING, bookingData);
            } else {
                commit(BOOK_END);
            }

            return data;

        } catch(e) {
            commit(BOOK_END);
        }

        return {
            success: false
        };
    },

    async [STANDGUIDANCE_CANCEL]({ commit, state }, cancelationData) {

        if (state.isCancelling) {
            return;
        }

        commit(CANCEL_START);

        try {
            const { data } = await StandGuidanceService.cancel(cancelationData);

            if (data.success) {
                commit(SET_STANDGUIDANCE_CANCELLED);
            } else {
                commit(CANCEL_END);
            }
        } catch(e) {
            commit(CANCEL_END);
        }

        return {
            success: false
        };
    },
};

const mutations = {

    [FETCH_START](state) {
        state.isLoading = true;
    },

    [FETCH_END](state) {
        state.isLoading = false;
    },

    [BOOK_START](state) {
        state.isBooking = true;
    },

    [BOOK_END](state) {
        state.isBooking = false;
    },

    [CANCEL_START](state) {
        state.isCancelling = true;
    },

    [CANCEL_END](state) {
        state.isCancelling = false;
    },

    [SET_STANDGUIDANCE](state, { data }) {
        state.isLoading = false;
        state.appointments = data;
    },

    [SET_BOOKED_STANDGUIDANCE](state, data) {

        state.isLoading = false;
        state.appointment = data.appointment;
    },

    [SET_STANDGUIDANCE_BOOKING](state, data) {

        state.isBooking = false;

        const appointments = {
            ...state.appointments
        };

        let newCount = 0;
        if (appointments.hasOwnProperty(data.appointment)) {
            newCount = appointments[data.appointment] + 1;
        }

        appointments[data.appointment] = newCount;

        Vue.set(state, 'appointments', appointments);

        state.appointment = data.appointment;
    },

    [SET_STANDGUIDANCE_CANCELLED](state) {

        state.isCancelling = false;

        const appointments = {};
        Object.keys(state.appointments).forEach((index) => {

            if (index == state.appointment) {
                state.appointments[index] -= 1;
            }

            if (state.appointments[index] > 0) {
                appointments[index] = state.appointments[index];
            }
        });

        Vue.set(state, 'appointments', appointments);
        state.appointment = null;
    },
};

const getters = {
    isLoading: (state) => {
        return state.isLoading;
    },

    isBooking: (state) => {
        return state.isBooking;
    },

    isCancelling: (state) => {
        return state.isCancelling;
    },

    getAppointments: (state) => {

        return state.appointments;
    },

    getUserAppointment: (state) => {
        return state.appointment;
    },

};


export const standGuidance = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
